const macNativeScripts = [
  {
    id: "24282760-b103-4a83-9b65-c433d7ec0f3d",
    name: "editors.policy.actions.ardDisable",
    categoryId: 3,
  },
  {
    id: "9D5007BF-D40A-4918-9B11-E80C5DD08F1D",
    name: "editors.policy.actions.FirewallEnable",
    categoryId: 3,
  },
  {
    id: "4bd4330a-260f-43e9-9709-ed28e8be767f",
    name: "editors.policy.actions.FirewallDisable",
    categoryId: 3,
  },
  {
    id: "b9db58e4-4eef-4ab8-ba64-96bd00df2a35",
    name: "editors.policy.actions.MacSleepDisable",
    categoryId: 3,
  },
  {
    id: "233d7933-d594-4199-8bd2-d3f65a176ca4",
    name: "editors.policy.actions.sshEnable",
    categoryId: 3,
  },
  {
    id: "8c8271b1-0f62-4924-93ca-0413857359b6",
    name: "editors.policy.actions.sshDisable",
    categoryId: 3,
  },
  {
    id: "050e5c9b-0640-4af1-b9b9-3804e3027d7c",
    name: "editors.policy.actions.vncDisable",
    categoryId: 3,
  },
  {
    id: "106c9c25-fead-4849-828c-87b0eb8174ad",
    name: "editors.policy.actions.ardEnable",
    categoryId: 3,
  },
  {
    id: "0b53f366-9bfd-47e0-ae80-23b1d13e9d1e",
    name: "editors.policy.actions.vncEnable",
    categoryId: 3,
  },
  {
    id: "dfe6db44-3cd5-4eae-b720-4e8d21133363",
    name: "editors.policy.actions.WakeOnLANEnable",
    categoryId: 3,
  },
  {
    id: "13e5be81-147c-4236-a7cc-bb8b512f4ab5",
    name: "editors.policy.actions.emptyTrash",
    categoryId: 3,
  },
  {
    id: "85c0859c-a7ba-4624-8909-8cecca1059fb",
    name: "editors.policy.actions.FlushDNS",
    categoryId: 3,
  },
  {
    id: "cea2dd60-8b2b-41fd-82f0-65c4371d496c",
    name: "editors.policy.actions.killCoreAudio",
    categoryId: 3,
  },
  {
    id: "68e8e0f7-0be1-4b14-8b4f-981161feb785",
    name: "editors.policy.actions.purgeDiskCache",
    categoryId: 3,
  },
  {
    id: "b2a071ff-cfbf-4573-9e6b-f642b15445c4",
    name: "editors.policy.actions.ReapplyUserPermissions",
    categoryId: 3,
  },
  {
    id: "40BE7B53-7567-4DFC-A434-E1E33DE752BA",
    name: "editors.policy.actions.Reboot",
    categoryId: 3,
  },
  {
    id: "e5a06cf8-1d8f-4652-86e0-941f96b6aefc",
    name: "editors.policy.actions.RepairDiskPerms",
    categoryId: 3,
  },
  {
    id: "7c3d5022-730c-4ab6-872a-a3803a62800b",
    name: "editors.policy.actions.RepairSSH",
    categoryId: 3,
  },
  {
    id: "e204e419-1e19-43ea-8239-d8f354f213a4",
    name: "editors.policy.actions.RepairTeamViewer",
    categoryId: 3,
  },
  {
    id: "11e7aa77-8de3-4e2a-99d9-b571b564c628",
    name: "editors.policy.actions.ResetLauncherService",
    categoryId: 3,
  },
  {
    id: "9eb4cf79-f55b-4094-9c05-4abd7d47646e",
    name: "editors.policy.actions.resetPrinting",
    categoryId: 3,
  },
  {
    id: "0524f2d4-dcf6-4f90-b031-5318916fd1fe",
    name: "editors.policy.actions.AutoUpdatesOff",
    categoryId: 3,
  },
  {
    id: "019e9e69-82b7-4346-a792-b48aea0fc384",
    name: "editors.policy.actions.WakeDisplay",
    categoryId: 3,
  },
  {
    id: "088f188c-c69c-4a85-8cb6-0dac0048a8ca",
    name: "editors.policy.actions.listAvailablePatches",
    categoryId: -1,
  },
  {
    id: "2322008f-a031-4241-a310-312bb1c9b923",
    name: "editors.policy.actions.downloadUpdatesNotInstall",
    categoryId: -1,
  },
  {
    id: "ee973456-bb9a-4e21-8c46-b52e0278fa3d",
    name: "editors.policy.actions.installOnlyRecommended",
    categoryId: -1,
  },
  {
    id: "f1444d7e-2a0e-4d87-96cf-97786d8f2097",
    name: "editors.policy.actions.installOnlyRecommendedRestart",
    categoryId: -1,
  },
  {
    id: "f395d725-3fa1-4350-8100-fa2b05d1fe34",
    name: "editors.policy.actions.installAllAvailable",
    categoryId: -1,
  },
  {
    id: "6db8fc5f-7169-4289-9691-be9378369346",
    name: "editors.policy.actions.installAllAvailableRestart",
    categoryId: -1,
  },
]

export default macNativeScripts
